// Розширення типів глобального вікна
declare global {
  interface Window {
    TelegramAdsController?: {
      initialize: (params: { pubId: string; appId: string }) => void
      triggerNativeNotification: (show: boolean) => Promise<any>
    }
  }
}

export class Richads {
  private static _instance: Richads
  private _initialized = false

  private constructor() {}

  public static get Instance(): Richads {
    if (!Richads._instance) {
      Richads._instance = new Richads()
    }
    return Richads._instance
  }

  /**
   * Ініціалізує скрипти та TelegramAdsController
   */
  public init(): Promise<void> {
    if (this._initialized) {
      return Promise.resolve()
    }

    return new Promise((resolve, reject) => {
      const scriptsToLoad = [
        'https://telegram.org/js/telegram-web-app.js?56',
        'https://richinfo.co/richpartners/telegram/js/tg-ob.js',
      ]

      let loadedCount = 0
      const onLoad = () => {
        loadedCount++
        if (loadedCount === scriptsToLoad.length) {
          try {
            // Створюємо об'єкт TelegramAdsController, якщо його немає
            if (!window.TelegramAdsController && (window as any).TelegramAdsController) {
              window.TelegramAdsController = new (window as any).TelegramAdsController()
            }
            if (!window.TelegramAdsController) {
              reject(new Error('TelegramAdsController не знайдений після завантаження скриптів'))
              return
            }
            window.TelegramAdsController.initialize({
              pubId: '966968',
              appId: '2804',
            })
            this._initialized = true
            resolve()
          } catch (err) {
            reject(err)
          }
        }
      }

      scriptsToLoad.forEach((src) => {
        const script = document.createElement('script')
        script.src = src
        script.async = true
        script.onload = onLoad
        script.onerror = () => reject(new Error(`Не вдалося завантажити скрипт ${src}`))
        document.head.appendChild(script)
      })
    })
  }

  /**
   * Показати reward рекламу, повертає Promise
   */
  public showAd_Rewarded(): Promise<any> {
    if (!window.TelegramAdsController) {
      return Promise.reject(new Error('TelegramAdsController не ініціалізовано'))
    }
    return window.TelegramAdsController.triggerNativeNotification(true)
  }
}
